
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Text from 'components/Text';

import { formatPrice } from 'helpers/Price';

import '../TotalPrice/totalPrice.styles.scss';

export default class SimpleTotalPrice extends Component {
    renderUnitPrice() {
        const {unitPrice, totalPrice, unitPriceText } = this.props;
        let price;

        if (unitPrice === totalPrice) {
            return null;
        }

        if (!unitPriceText) {
            price = formatPrice(unitPrice);
        } else {
            price = formatPrice(unitPrice) + ' / ' + unitPriceText;
        }

        return ` (${price})`;
    }
    render() {
        const { style, unitPrice, totalPrice, type, typeText, ValidToDateTime, hideValidToDateTime, separator } = this.props;

        if (unitPrice === false) {
            return null;
        }

        return (
            <div className="product__simpleprice-type" style={style}>
                {typeText && typeText !== '' &&
                    <Text textKey={typeText} />
                }
                {separator}
                {formatPrice(totalPrice)}
                {this.renderUnitPrice()}
                {ValidToDateTime && !hideValidToDateTime &&
                    (<div className={'product__valid-to product__valid-to-' + type}>
                        <Text textKey="price_package_valid_until" /> {ValidToDateTime}
                    </div>)
                }
            </div>
        );
    }
}

SimpleTotalPrice.propTypes = {
    style: PropTypes.object,
    unitPriceText: PropTypes.string,
    type: PropTypes.string.isRequired,
    typeText: PropTypes.string,
    article: PropTypes.any.isRequired,
    unitPrice: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.bool,
    ]).isRequired,
    totalPrice: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.bool,
    ]).isRequired,
    ValidToDateTime: PropTypes.any,
    hideValidToDateTime: PropTypes.bool,
    separator: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
};
